import { render, staticRenderFns } from "./InterventionEditionForm.vue?vue&type=template&id=653e96d4&"
import script from "./InterventionEditionForm.vue?vue&type=script&lang=js&"
export * from "./InterventionEditionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports